"use client";

import React from "react";
import { Details } from "../Details";
import { toDetailItems } from "../Nav/nav-content";
import { useNav } from "@/providers/Nav";

/**
 *
 * NavGuts
 *
 */
const NavGuts = ({ ...props }) => {
  const { topNavItems } = useNav();

  if (!topNavItems.length) {
    return null;
  }

  return (
    <div className="nav" {...props}>
      <Details items={toDetailItems(topNavItems, "flex gap-4 flex-wrap")} />
    </div>
  );
};

export default NavGuts;
